import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LoaderBox } from "src/components/LoaderBox";
import { PageLayout } from "src/components/PageLayout";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { ZUser } from "src/types";

import { UserFormData } from "../types";
import { singleUserStore } from "./SingleUserStore";
import { UserForm } from "./UserForm";

export const SingleUserPage: React.FC = observer(() => {
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    singleUserStore.loadUser(id);
    return () => {
      singleUserStore.clear();
    };
  }, [id]);
  return (
    <PageLayout title={singleUserStore.crumbs}>
      <LoaderBox
        remoteData={singleUserStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </PageLayout>
  );
});

type PropsInner = {
  data: ZUser | null;
};

const Inner: React.FC<PropsInner> = observer(({ data }) => {
  const navigate = useNavigate();
  const handleSubmit = async (formData: UserFormData) => {
    singleUserStore.saveUser(formData).then((result) => {
      if (result) {
        navigate(makeUrl(PageUrl.managementUserEdit, { id: result.id }));
      }
    });
  };
  const handleCancel = () => navigate(makeUrl(PageUrl.managementUsers));

  return (
    <UserForm
      sourceData={data ?? undefined}
      rolesRefStore={singleUserStore.rolesRefStore}
      disabled={singleUserStore.data.status !== "ready"}
      saving={singleUserStore.loading}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  );
});
